export enum DATA_QA {
  ROOT = 'phone-sidebar',
  EDIT = 'phone-sidebar__edit',
  MENU = 'phone-sidebar__menu',
  MENU_LIST = 'phone-sidebar__menu-list',
  MENU_ITEM = 'phone-sidebar__menu-item',
  DELETE_ITEM = 'phone-sidebar__delete-item',
}
